<app-advanced-tooltip>
  <tooltip-body>
    <span [class.condense]="condense" class="status-container">
      <mat-icon [class.blue]="isBlue()" [class.small-icon]="small" [class.yellow]="isYellow()" [color]="iconColor()"
                [ngClass]="status">traffic</mat-icon>
      <ng-container *ngIf="!condense">{{ status()?.type }}</ng-container>
    </span>
  </tooltip-body>
  <tooltip-popout>
    Created at {{ rma.created.at | date }}
    by
    <app-user [email]="rma.created.by"></app-user>
    <br/>
    Last updated at {{ rma.updated.at | date }}
    by
    <app-user [email]="rma.updated.by"></app-user>
    <br/>
    Last status {{ status()?.type }} at {{ status()?.date | date:'YYYY-MM-dd' }}
  </tooltip-popout>
</app-advanced-tooltip>
